export const nowSection = {
    getContent: () => {
        return `
        <div class="px-3">
        <section class="justify-content-around align-items-center d-flex py-5 mt-5 bg-light px__1 media__header__wrap">
            <p class="m-0 fw-bold">
                NOW's goal is to:
                <q>Build a future where people live in harmony with nature.</q>
            </p>
            <button class="btn btn-warning">
                Sign up for the NOW email
            </button>
        </section>
    </div>
        `;
    },
};